<script>
import api from '../../api';

export default {
  name: 'AdminUsers',
  data() {
    return {
      results: []
    };
  },
  methods: {
    searchForUsers: _.debounce(function(search) {
      if (search.length) {
        api.Admin.User.index({params: {search}})
          .then(results => this.results = results);
      } else {
        this.results = [];
      }
    }, 1000),
    impersonate(result) {
      this.$store.commit('logIn', result);
      this.$router.push({name: 'dashboard'});
    }
  }
}
</script>
<template>
  <div>
    <form>
      <div class="input-group">
        <label>SEARCH NAME/EMAIL</label>
        <input type="text" @input="searchForUsers($event.target.value)" placeholder="Kyle" class="input-control">
      </div>
    </form>
    <table>
      <thead>
        <tr>
          <th>First</th>
          <th>Last</th>
          <th>Email</th>
          <th>Created</th>
          <th>Confirmed</th>
          <th>Solvent Through</th>
          <th>Push Enabled?</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="result in results">
          <td>{{result.first_name}}</td>
          <td>{{result.last_name}}</td>
          <td>{{result.email}}</td>
          <td>{{result.created_at | pinhighDate}}</td>
          <td>{{!result.email_verification}}</td>
          <td>{{result.payments_solvent_through | pinhighDate}}</td>
          <td>{{result.android_push_id ? 'Android' : ''}}{{result.ios_push_id ? 'iOS' : ''}}</td>
          <td><button @click="impersonate(result)">Impersonate</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
